import baseService from '../shared/baseService';

const editedNewsFieldService = (newsId: number) => baseService(`news/${newsId}/edited-fields`);

export default { 
    editedNewsFieldService
};

